import React, { useEffect, useRef, useState } from 'react'
import { enumHLSearchDataType } from '../../VisualunitHelpers'
import { RootState } from '../../Redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { TGetFilterVal } from './GenericFilters'
import { IBusinessParamsOptions } from '../Reports/VisualUnitParamsDialog'
import { parseConvertedFilterDispText } from './ConvertFilterDisplayText'
import { IHLreturnData, updateDurationsFilterInputs } from '../VuParamsHelpers'

const replaceFilterValueParameter_HLAge = (
    replacedStr: any,
    listItemId: any,
    filterableId: any,
    filterValueListId: any,
    filterValue: string,
    GetFilterValues: (filterValArgs: TGetFilterVal) => void,
    selectedItem: string,
    selectedParameters: any,
    MetadataId: number
) => {
    // const getInputValuesRef = useRef<any>({})
    interface IHLAgeValues {
        HLAGE:string | undefined,
        HLAGE_FROM:string | undefined,
        HLAGE_TO:string | undefined,
    }
    const [HLAgeValues, setHLAgeValues] = useState<IHLAgeValues>({
        HLAGE: undefined,
        HLAGE_FROM: undefined,
        HLAGE_TO: undefined
    })
    const setInput = (key: string, value: any) => {
        if (key !== "" && value !== null) {
            let calculatedInputs = { ...HLAgeValues }
            calculatedInputs = {
                ...calculatedInputs,
                [key]: value === "" ? undefined : value //undefined helps in validations instead of empty string
            }
            setHLAgeValues(calculatedInputs)
            GetFilterValues({displayText: filterValue, selectedValues: calculatedInputs, keyValue: filterValueListId})
        }else{
            GetFilterValues({displayText: filterValue, selectedValues: "", keyValue: filterValueListId})
        }
        // Addmethod(inputs, replacedStr, filterableId, filterValueListId)
    }

    useEffect(() => {
            if(selectedItem != null){
                GetFilterValues({displayText: filterValue, selectedValues: HLAgeValues, keyValue: filterValueListId})
            }
        }, [selectedItem])

    useEffect(() => {
        if (selectedParameters.data !== null) {
            if (selectedParameters.data.filterValueListId == filterValueListId && selectedParameters.data.metaDataId == MetadataId) {
                updateDurationsFilterInputs(setHLAgeValues, "HLAGE", selectedParameters)
            }
        }else{
            setHLAgeValues({
                HLAGE: "18",
                HLAGE_FROM: "18",
                HLAGE_TO: "25"
            })
        }
    }, [])

    const parseReplacedStr = (str: string) => {
        // Define regex pattern for all placeholder types
        const regex = new RegExp(
            `\\[(${enumHLSearchDataType.HLAge}|${enumHLSearchDataType.HLAge_From}|${enumHLSearchDataType.HLAge_To})\\]`,
            'gi'
        )

        const parts = str.split(regex).filter(Boolean) // Split by placeholders and remove empty parts

        if (parts.length === 1) {
            return (
                <span
                    key="plain-text"
                    onClick={()=>setInput("", null)}>
                    {parts[0]}
                </span>
            );
        }

        const jsxParts = parts.map((part, index) => {
            // Handle the HLAge placeholder
            if (part === enumHLSearchDataType.HLAge) {
                return (
                    <input
                        key={index}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLAge}`}
                        size={3}
                        maxLength={3}
                        defaultValue={HLAgeValues.HLAGE}
                        autoComplete="off"
                        className="filtervalue-input-text input-numeric"
                        onChange={(e) => setInput(enumHLSearchDataType.HLAge, e.target.value)}
                    />
                )
            }

            // Handle the HLAge_From and HLAge_To placeholders (range)
            if (part === enumHLSearchDataType.HLAge_From) {
                return (
                    <>
                        <input
                            key={index}
                            type="text"
                            id={`${listItemId}_${enumHLSearchDataType.HLAge_From}`}
                            size={3}
                            maxLength={3}
                            defaultValue={HLAgeValues.HLAGE_FROM}
                            autoComplete="off"
                            className="filtervalue-input-text input-numeric"
                            onChange={(e) =>
                                setInput(enumHLSearchDataType.HLAge_From, e.target.value)
                            }
                        />
                    </>
                )
            }

            // Handle the HLAge_To placeholder (upper limit of range)
            if (part === enumHLSearchDataType.HLAge_To) {
                return (
                    <input
                        key={index}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLAge_To}`}
                        size={3}
                        maxLength={3}
                        defaultValue={HLAgeValues.HLAGE_TO}
                        autoComplete="off"
                        className="filtervalue-input-text input-numeric"
                        onChange={(e) => setInput(enumHLSearchDataType.HLAge_To, e.target.value)}
                    />
                )
            }

            // If it's just regular text, return it as is
            return part
        })

        return jsxParts
    }

    // Return the JSX for the replaced string
    return <>{parseReplacedStr(replacedStr)}</>
}

export default replaceFilterValueParameter_HLAge
